import { createContext } from "react";
import { JsonRpc } from "upcx-js";
import { Shard } from "upcx-js/dist/upcxjs-api-interfaces";
import { Quote } from "../openApi/api";

export interface ChainContextValue {
  jsonRpc?: JsonRpc;
  shards: Shard[];
  selectedShard?: Shard;
  quoteUSD?: Quote;
  quoteJPY?: Quote;
  handleChangeShard: (shardId: string) => void;
}

export const ChainContext = createContext<null | ChainContextValue>(null);
